import { formatOwnerData } from "../../../utils/ownerData/ownerData.util";
import { BillsTableRow } from "../../models/bills/bills.model";
import { CifCupsState } from "../../models/cupsCifSelector/cupsCifSelector.model";
import { UserData } from "../../models/login/login.model";
import {
  FormattedOwnerData,
  OwnerData,
} from "../../models/ownerData/ownerData.model";
import { SuppliesTableRow } from "../../models/supplies/supplies.model";

const getUserDataFromLocalStorage = (): UserData | null => {
  const userData: string | null = localStorage.getItem(
    process.env.REACT_APP_LOCALSTORAGE_USER_DATA!
  );

  if (userData) {
    const parsedOwnerData: UserData = JSON.parse(userData);
    return parsedOwnerData;
  }

  return null;
};

const setUserDataToLocalStorage = (userData: UserData): void => {
  const localStorageUserData = process.env.REACT_APP_LOCALSTORAGE_USER_DATA!;
  localStorage.setItem(localStorageUserData, JSON.stringify(userData));
};

const getOwnerDataFromLocalStorage = (): FormattedOwnerData | null => {
  const ownerData: string | null = localStorage.getItem(
    process.env.REACT_APP_LOCALSTORAGE_OWNER_DATA!
  );

  if (ownerData) {
    const parsedOwnerData: FormattedOwnerData = JSON.parse(ownerData);
    return parsedOwnerData;
  }

  return null;
};

const setOwnerDataToLocalStorage = (ownerData: OwnerData): void => {
  const localStorageOwnerData = process.env.REACT_APP_LOCALSTORAGE_OWNER_DATA!;
  localStorage.setItem(
    localStorageOwnerData,
    JSON.stringify(formatOwnerData(ownerData))
  );
};

const getCifCupsFromLocalStorage = (): CifCupsState | null => {
  const cifCups: string | null = localStorage.getItem(
    process.env.REACT_APP_LOCALSTORAGE_CIF_CUPS!
  );

  if (cifCups) {
    return JSON.parse(cifCups);
  }

  return null;
};

const setCifCupsToLocalStorage = (cifCups: CifCupsState): void => {
  const localStorageCifCups = process.env.REACT_APP_LOCALSTORAGE_CIF_CUPS!;
  localStorage.setItem(localStorageCifCups, JSON.stringify(cifCups));
};

const setSupplySelectedToLocalStorage = (
  supplySelected: SuppliesTableRow | null
) => {
  const localStorageSupplySelected =
    process.env.REACT_APP_SESSIONSTORAGE_SUPPLY_SELECTED!;
  sessionStorage.setItem(
    localStorageSupplySelected,
    JSON.stringify(supplySelected)
  );
};

const getSupplySelectedFromLocalStorage = () => {
  const localStorageSupplySelected =
    process.env.REACT_APP_SESSIONSTORAGE_SUPPLY_SELECTED!;
  const supplySelected = sessionStorage.getItem(localStorageSupplySelected);

  if (supplySelected) {
    return JSON.parse(supplySelected);
  }

  return null;
};

const setBillSelectedToLocalStorage = (billSelected: BillsTableRow | null) => {
  const localStorageBillSelected =
    process.env.REACT_APP_SESSIONSTORAGE_BILL_SELECTED!;
  sessionStorage.setItem(
    localStorageBillSelected,
    JSON.stringify(billSelected)
  );
};

const getBillSelectedFromLocalStorage = () => {
  const localStorageBillSelected =
    process.env.REACT_APP_SESSIONSTORAGE_BILL_SELECTED!;
  const billSelected = sessionStorage.getItem(localStorageBillSelected);

  if (billSelected) {
    return JSON.parse(billSelected);
  }

  return null;
};

export {
  getOwnerDataFromLocalStorage,
  setUserDataToLocalStorage,
  getUserDataFromLocalStorage,
  setOwnerDataToLocalStorage,
  getCifCupsFromLocalStorage,
  setCifCupsToLocalStorage,
  getSupplySelectedFromLocalStorage,
  setSupplySelectedToLocalStorage,
  getBillSelectedFromLocalStorage,
  setBillSelectedToLocalStorage,
};
